import React from "react";
import PropTypes from "prop-types";
import { Header } from "../../Header";
import { MainContent } from "./MainContent";
import { Footer, Submit } from "../Footer";
import "./style.scss";

/**
 * LabelTestTube:
 *  - You have n number of test tubes that needs to be labelled
 */
export function LabelTestTube(props) {
  const setSubmitDisable = () => {
    if (props.complete) return true;
    else {
      const unsubmittedOption = props.samples.find(
        (sample) => sample.currentValue != null && sample.showFeedback === false
      );
      return !unsubmittedOption;
    }
  };

  return (
    <div className="labelTestTube">
      <Header label={props.label} />
      <MainContent
        samples={props.samples}
        question={props.question}
        tubeType={props.tubeType}
        onDropdownChange={props.onDropdownChange}
      />
      <Footer>
        <Submit onSubmit={props.onSubmit} disabled={setSubmitDisable()}>
          Submit
        </Submit>
      </Footer>
    </div>
  );
}

LabelTestTube.propTypes = {
  /**
   * String for card heading
   */
  label: PropTypes.string.isRequired,
  /**
   * String representing question of the card
   */
  question: PropTypes.string.isRequired,
  /**
   * List of TestTube items.
   */
  samples: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique id for the sample
       */
      id: PropTypes.number,
      /**
       * Label for the sample
       */
      label: PropTypes.string,
      /**
       * Correct label value for testTube
       */
      actualValue: PropTypes.number,
      /**
       * List of label options to show in dropdown
       */
      options: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * Label for option
           */
          label: PropTypes.string,
          /**
           * Unique number value for option
           */
          value: PropTypes.number,
        })
      ),
      /**
       * Value of option selected now
       */
      currentValue: PropTypes.oneOfType([
        PropTypes.oneOf([null]),
        PropTypes.number,
      ]),
      /**
       * boolean to specify if feedback should be displayed for options.
       */
      showFeedback: PropTypes.bool,
    })
  ).isRequired,
  /**
   * Funciton to invoke when an option is selected
   */
  onDropdownChange: PropTypes.func.isRequired,
  /**
   * Callback function to execute when close button is clicked
   */
  onClose: PropTypes.func,
  /**
   * Funciton to invoke when answer is submitted
   */
  onSubmit: PropTypes.func.isRequired,
  /**
   * Image Compnent to set be set as TestTubeImage
   */
  tubeType: PropTypes.oneOf(["TUBE", "GLASS_TUBE"]),
};

LabelTestTube.defaultProps = {
  samples: [],
  tubeType: "TUBE",
};
